import React, {useState, useEffect} from 'react';
import styles from '../../../assets/styles/modules/SameNewsSideBar.module.css'
import {getSimilarNewsAPI} from "../../../apis/news_service";

const SameNewsSideBar = ({newsId}) => {

    const [sameNewsList, setSameNewsList] = useState([])

    useEffect(()=> {
        getSimilarNewsAPI(newsId, 15).then(res => setSameNewsList(res))
    }, [])

    const moveToSingleNews = (id) => window.location.replace(`/single-news/${id}`)

    return (
        <>
            {sameNewsList.length > 0 &&
                    <div  className={styles.side_menu}>
                        <p  className={styles.title}>연관보도</p>
                        {sameNewsList.map(news =>
                            <>
                                <p className={styles.subject} onClick={()=>moveToSingleNews(news.newsid)}>{news.subject}</p>
                                <div className={styles.divider}/>
                            </>
                        )}
                    </div>
            }
        </>

    );
};

export default SameNewsSideBar;